/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketplace_Seo_Galicia_Faq_Q3Inputs */

const es_marketplace_seo_galicia_faq_q3 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Necesito licencia para alquilar un barco en Galicia?`)
};

const gl_marketplace_seo_galicia_faq_q3 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Necesito licenza para aluguer un barco en Galicia?`)
};

const en_marketplace_seo_galicia_faq_q3 = /** @type {(inputs: Marketplace_Seo_Galicia_Faq_Q3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need a licence to rent a boat in Galicia?`)
};

/**
* | output |
* | --- |
* | "Do I need a licence to rent a boat in Galicia?" |
*
* @param {Marketplace_Seo_Galicia_Faq_Q3Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const marketplace_seo_galicia_faq_q3 = /** @type {((inputs?: Marketplace_Seo_Galicia_Faq_Q3Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketplace_Seo_Galicia_Faq_Q3Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_marketplace_seo_galicia_faq_q3(inputs)
	if (locale === "en") return en_marketplace_seo_galicia_faq_q3(inputs)
	return es_marketplace_seo_galicia_faq_q3(inputs)
});